<template>
	<div>
		<AppFilter @apply="onFilter" v-model="filters" @retainValues = "retainFilter" ref="appFilter"/>
	</div>
</template>

<script>
	import AppFilter from "@/components/core/indexNew.vue";
	export default {
		props: {
			// selectedVendorFilter: {},
			// selectedCampGroupFilter: {}
			profileTags: {},
			countryList: {},
			searchSpecialists: {},
		},
		beforeMount() {},
		components: {
			AppFilter
		},
		watch: {
			// selectedVendorFilter() {
			// 	this.setFilters();
			// },
			// selectedCampGroupFilter() {
			// 	this.setFilters();
			// }
			profileTags () {
				console.log(this.profileTags)
				this.setFilters()
			},
			countryList () {
				console.log(this.countryList)
				this.setFilters()
			},
			searchSpecialists () {
				console.log(this.searchSpecialists)
				this.setFilters()
			}
		},
		computed: {
			campaignsFilter:{
				set(val){
					this.$store.commit('updateCampaignsFilter',val)
				},
				get(){
					return this.$store.state.campaignsFilter
				}
			},
			selectedCampaignList: {
				get() {
					return this.$store.state.campaign.campaignToAddToGroupList;
				},
				set(val) {
					this.$store.state.campaign.campaignToAddToGroupList = val;
				}
			},
			actionSelectionControl: {
				set(val) {
					this.$store.state.campaign.actionSelectionControl = val
				},
				get() {
					return this.$store.state.campaign.actionSelectionControl
				}
			},
			// vendorsList() {
			// 	// set(val) {
			// 	// 	this.$store.commit("updateVendorList", val);
			// 	// },
			// 	// get() {
			// 	return this.$store.state.vendorList;
			// 	// }
			// },
			// campaignGroupFilterList() {
			// 	// set(val) {
			// 	// 	this.$store.commit(
			// 	// 		"campaign/updateCampaignGroupFilterList",
			// 	// 		val
			// 	// 	);
			// 	// },
			// 	// get() {
			// 	return this.$store.state.campaign.campaignGroupFilterList;
			// 	// }
			// }
		},
		async mounted() {
			if(Object.keys(this.$store.state.campaign.advanceFilter).length && this.campaignsFilter.length){
				this.filters = JSON.parse(JSON.stringify(this.campaignsFilter))
				this.$refs["appFilter"].setFilterActive();
			}
			else{
				this.setFilters();
				// this.$refs["appFilter"].setFilterInActive();
			}
		},
		methods: {
			retainFilter(data){
				 ;
				// console.log(this.filteredValues);
				// for (var obj in this.filteredValues) {
				// 	let index = this.filters.findIndex((res) => {
				// 		obj == res.name
				// 	})
				// 	// this.filters[index].enabled = true;
				// 	// this.filters[index].value = {name: this.filteredValues[obj]}
				// }

				if(Object.keys(this.$store.state.campaign.advanceFilter).length){
					this.filters = JSON.parse(JSON.stringify(this.campaignsFilter)) || []
				}
				else{
					this.filters = JSON.parse(JSON.stringify(data)) 
				}
				
			},
			async onFilter(input) {
				let filters = {};

				// this.$emit("setVendorAndCampaign", {
				// 	campGrpId: { id: "" },
				// 	vendorId: { id: "" }
                // });
				for (var i = 0; i < input.length; i++) {
					// if (
					// 	input[i].name[1].subName &&
					// 	input[i].name[1].subName == "campaign_group_name"
					// ) {
					// 	this.$emit("setVendorAndCampaign", {
					// 		campGrpId: input[i].value[1].subValue
					// 			? input[i].value[1].subValue
					// 			: "",
					// 		// ? input[i].value[1].subValue.id
					// 		// 	? input[i].value[1].subValue.id
					// 		// 	: input[i].value[1].subValue.code
					// 		// 	? input[i].value[1].subValue.code
					// 		// 	: null
					// 		// : null
					// 		vendorId: input[i].value[0].value
					// 			? input[i].value[0].value
					// 			: ""
					// 		// ? input[i].value[0].value.id
					// 		// 	? input[i].value[0].value.id
					// 		// 	: input[i].value[0].value.code
					// 		// 	? input[i].value[0].value.code
					// 		// 	: null
					// 		// : null
					// 	});
					// 	// let element = { code: "", name: "" };
					// 	// if (input[i].value[1].subValue) {
					// 	// 	element.code = input[i].value[1].subValue.id
					// 	// 		? input[i].value[1].subValue.id
					// 	// 		: input[i].value[1].subValue.code;
					// 	// 	element.name = input[i].value[1].subValue.name;
					// 	// }
					// 	// filters[input[i].name[1].subName] = element;
					// 	let firstElement = { code: "", name: "" };
					// 	if (input[i].value[0].value) {
					// 		firstElement.code = input[i].value[0].value.id
					// 			? input[i].value[0].value.id
					// 			: input[i].value[0].value.code;
					// 		firstElement.name = input[i].value[0].value.name;
					// 	}
					// 	filters[input[i].name[0].name] = firstElement;
                    // } else
                    {
						filters[input[i].name] = input[i].value;
					}
                }
				filters.advanceSearchType = "campaign";
				let payload = {tags: []};
				if(filters["campaign_type"]){
					payload.campaign_type = filters["campaign_type"].code
				}
				if(filters["mso"]){
					payload.state = filters["mso"].name
				}
				if(filters["status"]){
					payload.status = filters["status"].code
				}

				//campaign tag section
				if(filters['brand_tag']){
					payload.tags.push(filters['brand_tag'])
				}
				if(filters['category_tag']){
					payload.tags.push(filters['category_tag'])
				}
				if(filters['subcategory_tag']){
					payload.tags.push(filters['subcategory_tag'])
				}
				if(filters['style_tag']){
					payload.tags.push(filters['style_tag'])
				}
				if(filters['tactic1_tag']){
					payload.tags.push(filters['tactic1_tag'])
				}
				if(filters['tactic2_tag']){
					payload.tags.push(filters['tactic2_tag'])
				}
				if(filters['gl_tag']){
					payload.tags.push(filters['gl_tag'])
				}
				
				if(filters['country']){
					payload.country = filters['country'].code
					payload.countryFilter = filters['country']
				}
				if(filters['search_specialist']){
					payload.search_specialist = filters['search_specialist'].code
					payload.search_specialistFilter = filters['search_specialist']
				}
				this.resetCampAction();
				this.$store.state.currentPageNumber = 1;
				this.$store.commit("campaign/setadvanceFilterAttributes", payload);
				console.log(this.$store.state.advanceFilter)
				this.$store.dispatch("campaign/getCampaignList");
			},
			resetCampAction(){
				this.actionSelectionControl = false
				this.selectedCampaignList = []
			},
			setFilters() {
				this.filters = [];
				// let currentVendorObject = {};
				// let currentCampGroupObject = {};
				// if (this.selectedVendorFilter) {
				// 	//currentVendorObject = this.setVendor(this.selectedVendorFilter.id);
				// 	currentVendorObject = this.selectedVendorFilter;
				// 	if (this.selectedCampGroupFilter) {
				// 		//currentCampGroupObject = this.setCampGrp(this.selectedCampGroupFilter.id);
				// 		currentCampGroupObject = this.selectedCampGroupFilter;
				// 	}
				// }

				this.filters = [
                    {
						name: "break",
						type: "break"
					},
					{
						name: "campaign_type",
						label: "Campaign type",
						type: "select",
						padding:true,
						placeholder: "Select campaign type",
						value: [],
						enabled: false,
						values: [
							{
								name: "Sponsored Products",
								code: "sponsoredProducts"
							},
							{
								name: "Sponsored Brands",
								 code: "sponsoredBrands"
							 },
							 {
								 name:"Sponsored Display",
								 code:"sponsoredDisplay"
							 },
							 {
								 name:"Sponsored TV",
								 code:"sponsoredTv"
							 }
						]
					},
					{
						name: "break",
						type: "break"
					},
					{
						name: "mso",
						label: "Shut Off",
						type: "select",
						placeholder: "Select State",
						padding:true,
						value: [],
						enabled: false,
						values: [
							{ name: "AMSO", code: "ams_shutoff" },
							{ name: "MLSO", code: "midnight_shutoff" },
							{ name: "MNSO", code: "ml_shutoff" },
							{ name: "ACTIVE", code: "active" }
						]
					},
					{
						name: "break",
						type: "break"
                    },
                    {
						name: "status",
						label: "Status",
						type: "select",
						padding:true,
						placeholder: "Select Status",
						value: [],
						enabled: false,
						values: [
							{
								name: "Enabled",
								code: "enabled"
							},
                            { name: "Paused", code: "paused" },
                            { name: "Archived", code: "archived" }
						]
                    },
                    {
						name: "break",
						type: "break"
                    },
					{
						name: "country",
						label: "Country",
						type: "select",
						padding:true,
						placeholder: "Select Country",
						value: this.$store.state.campaign.advanceFilter.country ? this.$store.state.campaign.advanceFilter.countryFilter : [],
						enabled: !!this.$store.state.campaign.advanceFilter.country,
						values: this.countryList.map(country => ({name: country, code: country}))
                    },
					{
						name: "break",
						type: "break"
                    },
					{
						name: "search_specialist",
						label: "Search Specialist",
						type: "select",
						padding:true,
						placeholder: "Select Specialist",
						value: this.$store.state.campaign.advanceFilter.search_specialist ? this.$store.state.campaign.advanceFilter.search_specialist.search_specialistFilter : [],
						enabled: !!this.$store.state.campaign.advanceFilter.search_specialist,
						values: this.searchSpecialists.map(s => ({name: `${s.first_name} ${s.last_name}`, code: {first_name: s.first_name, last_name: s.last_name}}))
                    },
					{
						name: "break",
						type: "break"
                    },
					{
						name: "brand_tag",
						label: "Brand Tag",
						type: "campaign_tag",
						padding:true,
						placeholder: "Select Brand",
						value: this.$store.state.campaign.advanceFilter.tags ? this.$store.state.campaign.advanceFilter.tags.filter(tag => tag.type === 'campaign_brand') : [],
						enabled: !!this.$store.state.campaign.advanceFilter.tags && !!(this.$store.state.campaign.advanceFilter.tags.filter(tag => tag.type === 'campaign_brand') || []).length,
						values: [{title: 'UNTAGGED', type:'campaign_brand', untagged: true}].concat(this.profileTags.filter(tag => tag.type === 'campaign_brand')),
						color: "#2F5BC2"
                    },
					{
						name: "break",
						type: "break"
                    },
					{
						name: "category_tag",
						label: "Category Tag",
						type: "campaign_tag",
						padding:true,
						placeholder: "Select Category",
						value: this.$store.state.campaign.advanceFilter.tags ? this.$store.state.campaign.advanceFilter.tags.filter(tag => tag.type === 'campaign_category') : [],
						enabled: !!this.$store.state.campaign.advanceFilter.tags && !!(this.$store.state.campaign.advanceFilter.tags.filter(tag => tag.type === 'campaign_category') || []).length,
						values: [{title: 'UNTAGGED', type:'campaign_category', untagged: true}].concat(this.profileTags.filter(tag => tag.type === 'campaign_category')),
						color: "#1C919E"

                    },
					{
						name: "break",
						type: "break"
                    },
					{
						name: "subcategory_tag",
						label: "Sub-Category Tag",
						type: "campaign_tag",
						padding:true,
						placeholder: "Select Subcategory",
						value: this.$store.state.campaign.advanceFilter.tags ? this.$store.state.campaign.advanceFilter.tags.filter(tag => tag.type === 'campaign_subcategory') : [],
						enabled: !!this.$store.state.campaign.advanceFilter.tags && !!(this.$store.state.campaign.advanceFilter.tags.filter(tag => tag.type === 'campaign_subcategory') || []).length,
						values: [{title: 'UNTAGGED', type:'campaign_subcategory', untagged: true}].concat(this.profileTags.filter(tag => tag.type === 'campaign_subcategory')),
						color: "#D98F34"
                    },
					{
						name: "break",
						type: "break"
                    },
					{
						name: "style_tag",
						label: "Style Tag",
						type: "campaign_tag",
						padding:true,
						placeholder: "Select Style",
						value: this.$store.state.campaign.advanceFilter.tags ? this.$store.state.campaign.advanceFilter.tags.filter(tag => tag.type === 'campaign_style') : [],
						enabled: !!this.$store.state.campaign.advanceFilter.tags && !!(this.$store.state.campaign.advanceFilter.tags.filter(tag => tag.type === 'campaign_style') || []).length,
						values: [{title: 'UNTAGGED', type:'campaign_style', untagged: true}].concat(this.profileTags.filter(tag => tag.type === 'campaign_style')),
						color: "#6A61BA"

                    },
					{
						name: "break",
						type: "break"
                    },
					{
						name: "tactic1_tag",
						label: "Tactic 1 Tag",
						type: "campaign_tag",
						padding:true,
						placeholder: "Select Tactic 1",
						value: this.$store.state.campaign.advanceFilter.tags ? this.$store.state.campaign.advanceFilter.tags.filter(tag => tag.type === 'campaign_tactic1') : [],
						enabled: !!this.$store.state.campaign.advanceFilter.tags && !!(this.$store.state.campaign.advanceFilter.tags.filter(tag => tag.type === 'campaign_tactic1') || []).length,
						values: [{title: 'UNTAGGED', type:'campaign_tactic1', untagged: true}].concat(this.profileTags.filter(tag => tag.type === 'campaign_tactic1')),
						color: "#60AEF7"

                    },
					{
						name: "break",
						type: "break"
                    },
					{
						name: "tactic2_tag",
						label: "Tactic 2 Tag",
						type: "campaign_tag",
						padding:true,
						placeholder: "Select Tactic 2",
						value: this.$store.state.campaign.advanceFilter.tags ? this.$store.state.campaign.advanceFilter.tags.filter(tag => tag.type === 'campaign_tactic2') : [],
						enabled: !!this.$store.state.campaign.advanceFilter.tags && !!(this.$store.state.campaign.advanceFilter.tags.filter(tag => tag.type === 'campaign_tactic2') || []).length,
						values: [{title: 'UNTAGGED', type:'campaign_tactic2', untagged: true}].concat(this.profileTags.filter(tag => tag.type === 'campaign_tactic2')),
						color: "#C94024"

                    },
					{
						name: "break",
						type: "break"
                    },
					{
						name: "gl_tag",
						label: "GL Tag",
						type: "campaign_tag",
						padding:true,
						placeholder: "Select GL",
						value: this.$store.state.campaign.advanceFilter.tags ? this.$store.state.campaign.advanceFilter.tags.filter(tag => tag.type === 'campaign_gl') : [],
						enabled: !!this.$store.state.campaign.advanceFilter.tags && !!(this.$store.state.campaign.advanceFilter.tags.filter(tag => tag.type === 'campaign_gl') || []).length,
						values: [{title: 'UNTAGGED', type:'campaign_gl', untagged: true}].concat(this.profileTags.filter(tag => tag.type === 'campaign_gl')),
						color: "#5E5E5E"
                    },
					{
						name: "break",
						type: "break"
                    },

				];
				this.campaignsFilter = JSON.parse(JSON.stringify(this.filters))
			},
			// setVendor(selectedVendorId) {
			// 	var data = { code: "", name: "" };
			// 	for (var i = 0; i < this.vendorsList.length; i++) {
			// 		if (selectedVendorId == this.vendorsList[i].id) {
			// 			data.code = this.vendorsList[i].id;
			// 			data.name = this.vendorsList[i].name;
			// 			break;
			// 		}
			// 	}
			// 	return data;
			// },
			// setCampGrp(selectedCampGrpId) {
			// 	var data = { code: "", name: "" };
			// 	for (var i = 0; i < this.campaignGroupList.length; i++) {
			// 		if (selectedCampGrpId == this.campaignGroupList[i].id) {
			// 			data.code = this.campaignGroupList[i].id;
			// 			data.name = this.campaignGroupList[i].name;
			// 			break;
			// 		}
			// 	}
			// 	return data;
			// }
		},
		data() {
			return {
				filters: [],
			};
		}
	};
</script>
<style lang="scss">
.multiselect__content-wrapper {
	z-index: 1001;
}
</style>
